module.exports = __webpack_public_path__ + "static/img/1.c8290d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/sp/1.png
// module id = GKBo
// module chunks = 0